import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-what-to-know-nh',
  imports: [TranslateModule],
  templateUrl: './what-to-know-nh.component.html',
  styleUrl: './what-to-know-nh.component.scss'
})
export class WhatToKnowNhComponent {

}
